import styled, { css } from 'styled-components';
import { ModalProps } from './Modal';

export const ModalBackdrop = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.2);
	display: grid;
	place-content: center;
	z-index: 99;
`;

export const ModalContainer = styled.div`
	${({ theme }) => css`
		box-shadow: ${theme.shadows.base};
		border-radius: ${theme.radii.default};
		overflow: hidden;
	`};
`;

export const ModalHeader = styled.div`
	${({ theme }) => css`
		position: relative;
		width: 508px;
		height: 63px;
		padding: 12px 32px;
		background-color: ${theme.colors.neutral[200]};
	`};
`;

export const HeaderArrow = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: -5px;
`;

export const ModalHeaderPrepend = styled.div`
	${({ theme }) => css`
		width: 38px;
		height: 38px;
		display: grid;
		place-content: center;
		background-color: ${theme.colors.neutral[100]};
		border-radius: ${theme.radii.m};
	`};
`;

export const ModalHeaderTitle = styled.div`
	${({ theme }) => css`
		text-transform: uppercase;
		font-weight: ${theme.fontWeights.bold};
		font-size: ${theme.fontSizes.default};
	`};
`;

export const ModalHeaderClose = styled.div`
	cursor: pointer;
`;

export const ModalContent = styled.div<ModalProps>`
	${({ theme, $fitToChildren }) => css`
		background-color: ${theme.colors.neutral[100]};
		width: 508px;
		${!$fitToChildren && 'min-height: 250px;'}
		padding: 22px 30px;
	`};
`;
